module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/qr-code-preauth-ae1d5b8e454bda75932349e273bd5f97.png";